import Vue from "vue"
import vTitle from "vuejs-title"

Vue.use(vTitle, {
	cssClass: "vtooltip",
	fontSize: "12px",
	round: "8px",
})
